export default "__VITE_ASSET__e5233a5f__"